import { render, staticRenderFns } from "./AllService.vue?vue&type=template&id=6f4c127a&scoped=true&"
import script from "./AllService.vue?vue&type=script&lang=js&"
export * from "./AllService.vue?vue&type=script&lang=js&"
import style0 from "./AllService.vue?vue&type=style&index=0&id=6f4c127a&prod&scoped=true&lang=css&"
import style1 from "./AllService.vue?vue&type=style&index=1&id=6f4c127a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c127a",
  null
  
)

export default component.exports